import(/* webpackMode: "eager" */ "/app/src/app/summer-camp/page.tsx")